<div class="about-us-home">
  <!-- Section 1: About (Left) and Image (Right) -->
  <div class="about-us-home--section">
    <app-about></app-about>
  </div>

  <!-- Section 3: How it works? (left) and MahaAgX as DPI (right) -->
  <div class="about-us-home--section about-us-home--two-column">
    <app-how-it-works></app-how-it-works>
    <app-mahaagx-dpi></app-mahaagx-dpi>
  </div>

  <!-- Section 5: Core Capabilities of MahaAgX -->
  <div class="about-us-home--section">
    <app-core-capabilities></app-core-capabilities>
  </div>

  <!-- Section 6: Key Platform Features -->
  <div class="about-us-home--section">
    <app-key-platform-features></app-key-platform-features>
  </div>

  <!-- Section 7: Who Benefits -->
  <div class="about-us-home--section">
    <app-benefits></app-benefits>
  </div>

  <!-- Section 6: Vision Statement (Left) and Key Objectives (Right) -->
  <!-- <div class="about-us-home--section about-us-home--two-column">
    <app-vision-statement></app-vision-statement>
    <app-key-objectives></app-key-objectives>
  </div> -->

  <!-- Section 5: Benefits -->
  <!-- <div class="about-us-home--section">
    <app-benefits></app-benefits>
  </div> -->

  <!-- Section 6: Principles -->
  <!-- <div class="about-us-home--section">
    <app-principles></app-principles>
  </div> -->

  <!-- Footer -->
  <app-footer></app-footer>
</div>

